<template>
  <div class="flex flex-col space-y-6 p-6 min-h-screen">
    <div v-if="kpiStats" class="space-y-6">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6"
      >
        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex
             items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/vehicule_N.png"
              alt="Icône pour le total des véhicules"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Véhicules sortis
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.totalVehicles }}
            </p>
          </div>
        </div>

        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/vehiculein_N.png"
              alt="Icône pour les véhicules présents"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Véhicules présents
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.ongoingVehicles }}
            </p>
          </div>
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          ></div>
        </div>

        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/heurepointe_N.png"
              alt="Icône pour l'heure de pointe"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Heure d'affluence
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.peakHour || "N/A" }}
            </p>
          </div>
        </div>

        <div
          class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch"
        >
          <div
            class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg"
          >
            <img
              src="@/assets/duree_N.png"
              alt="Icône pour la durée moyenne de parking"
              class="h-20 w-auto object-contain"
            />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5
              class="text-gray-600 text-xs font-medium text-center uppercase mb-1"
            >
              Durée moyenne
            </h5>
            <p class="text-3xl font-bold" style="color: #ec4400">
              {{ kpiStats.averageDuration }}
            </p>
          </div>
        </div>

      </div>
    </div>

    <div v-else class="text-center text-gray-600">
      Chargement des statistiques...
    </div>

    <div v-if="errorMessage" class="text-center text-red-600">
      {{ errorMessage }}
    </div>

    <div
      class="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0 sm:space-x-3"
    >
      <div class="flex items-center space-x-3 w-full flex-wrap sm:flex-nowrap">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Rechercher par nom, immatriculation, entreprise, pièce d'identité"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-full sm:w-2/5"
        />

        <input
          type="date"
          v-model="startDate"
          placeholder="Date Début"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"
        />
        <input
          type="date"
          v-model="endDate"
          placeholder="Date Fin"
          class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"
        />

        <button
          v-if="startDate || endDate || searchQuery"
          @click="clearFilters"
          class="bg-gray-200 text-gray-700 px-3 py-2 rounded-lg text-sm hover:bg-gray-300 transition-colors duration-200 flex-shrink-0"
        >
          Effacer
        </button>
      </div>

      <button
        @click="downloadPdf"
        class="text-white px-4 py-2 rounded-2xl text-sm hover:bg-white transition-colors duration-200 flex items-center space-x-2 w-full sm:w-auto flex-grow sm:flex-grow-0"
      >
        <i class="fas fa fa-download text-lg text-[#ec4400]"></i>
      </button>
    </div>

    <div
      class="bg-white shadow-sm rounded-lg border border-[#ec4400] overflow-hidden"
    >
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm text-left text-gray-700">
          <thead
            class="bg-gray-50 text-xs uppercase font-semibold text-gray-500"
          >
            <tr>
              <th class="px-3 py-2 text-xs">Utilisateur Entrée</th>
              <th class="px-3 py-2 text-xs">Utilisateur Sortie</th>
              <th class="px-3 py-2 text-xs">Numéro pièce</th>
              <th class="px-3 py-2 text-xs">Immatriculation</th>
              <th class="px-3 py-2 text-xs">Nom</th>
              <th class="px-3 py-2 text-xs">Prénoms</th>
              <th class="px-3 py-2 text-xs">Numéro de Badge</th>
              <th class="px-3 py-2 text-xs">Personne Visitée</th>
              <th class="px-3 py-2 text-xs">Département</th>
              <th class="px-3 py-2 text-xs">Entreprise</th>
              <th class="px-3 py-2 text-xs">Entrée</th>
              <th class="px-3 py-2 text-xs">Sortie</th>
              <th class="px-3 py-2 text-xs">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="vehicule in transformedVehicles"
              :key="vehicule.id"
              class="border-b border-gray-100 hover:bg-gray-50"
            >
              <td class="px-3 py-2">{{ vehicule.agent_entrance_name || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.agent_departure_name || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.id_card || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.id_car || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.sirname || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.first_name || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.badge_number || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.visited_person || " —" }}</td>
              <td class="px-3 py-2">{{ vehicule.department || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.company || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.entrance_time || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.exit_time || "—" }}</td>
              <td class="px-3 py-2">{{ vehicule.entrance_date || "—" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="flex justify-between items-center p-4 border-t border-gray-200"
      >
        <button
          class="px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          <img
            src="@/assets/flecheap.png"
            alt="Flèche page précédente"
            class="h-5 w-auto object-contain"
          />
        </button>
        <span class="text-sm text-gray-600">
          Page {{ currentPage }} / {{ totalPages }}
        </span>
        <button
          class="px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="currentPage === totalPages || totalPages === 0"
          @click="nextPage"
        >
          <img
            src="@/assets/flecheav.png"
            alt="Flèche page suivante"
            class="h-5 w-auto object-contain"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from "vue";
import html2pdf from "html2pdf.js";
import apiFetch from '@/apiClient';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: "VehiculeDashboard",
  setup() {
    // --- États (Réfs) ---
    const vehicles = ref({ data: [], totalCount: 0 });
    const searchQuery = ref("");
    const currentPage = ref(1);
    const itemsPerPage = 15;
    const sortColumn = ref("entrance_date");
    const sortDirection = ref("desc");
    const startDate = ref("");
    const endDate = ref("");
    const kpiStats = ref(null);
    const errorMessage = ref("");
    
    // NOUVEAU: Stocker le mapping ID -> Username
    const usersMap = ref({});

    // --- FONCTION DE RÉCUPÉRATION DES AGENTS (UTILISATEURS) ---
    const fetchUsersMap = async () => {
      try {
        const usersList = await apiFetch('/auth/users');
        const map = {};
        usersList.forEach((user) => {
          if (user.id && user.username) {
            map[user.id] = user.username;
          }
        });
        usersMap.value = map;
      } catch (err) {
        console.error("Erreur fetch Users Map:", err);
        errorMessage.value = `Impossible de charger la liste des agents. Affichage des IDs seulement.`;
      }
    };


    // --- Fonctions de Récupération des Données de Véhicules ---

    const fetchvehicles = async () => {
      try {
        errorMessage.value = "";
        // 1. Construction des paramètres de requête
        const params = new URLSearchParams({
          page: currentPage.value,
          limit: itemsPerPage,
          sortColumn: sortColumn.value,
          sortDirection: sortDirection.value,
        });

        // Appliquer todayOnly=true par défaut si tri par défaut et aucun filtre
        const isDefaultSort =
          sortColumn.value === "entrance_date" &&
          sortDirection.value === "desc";
        const hasFilters = searchQuery.value || startDate.value || endDate.value;
        if (isDefaultSort && !hasFilters) {
          params.append("todayOnly", "true");
        }

        if (searchQuery.value) {
          params.append("search", searchQuery.value);
        }
        if (startDate.value) {
          params.append("startDate", startDate.value);
        }
        if (endDate.value) {
          params.append("endDate", endDate.value);
        }

        const url = `${API_URL}/vehicles?${params.toString()}`;

        const response = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
        });
        if (!response.ok) throw new Error("Erreur réseau ou réponse invalide");

        const result = await response.json();
        vehicles.value = {
          data: result.data || [],
          totalCount: result.totalCount || 0,
        };
      } catch (err) {
        console.error("Erreur fetch véhicules :", err);
        vehicles.value = { data: [], totalCount: 0 };
        errorMessage.value = `Erreur lors du chargement des véhicules: ${err.message}`;
      }
    };

    const fetchKpiStats = async () => {
      try {
        kpiStats.value = await apiFetch('/vehicles/dashboard-stats');
      } catch (err) {
        console.error("Erreur fetch KPI :", err);
      }
    };

    /* * ----------------------------------------------------
     * PROPRIÉTÉS CALCULÉES (COMPUTED)
     * ----------------------------------------------------
     */
    // NOUVEAU: Transforme les IDs en Noms pour l'affichage
    const transformedVehicles = computed(() => {
      // Si les données de véhicules sont vides, retourne un tableau vide.
      if (!vehicles.value.data.length) {
        return [];
      }

      // Mappe les IDs aux noms
      return vehicles.value.data.map((vehicule) => {
        const entranceUser =
          usersMap.value[vehicule.user_entrance] ||
          vehicule.user_entrance ||
          "—";
        const departureUser =
          usersMap.value[vehicule.user_departure] ||
          vehicule.user_departure ||
          "—";

        return {
          ...vehicule,
          // Nouveaux champs pour le template
          agent_entrance_name: entranceUser,
          agent_departure_name: departureUser,
        };
      });
    });

    const totalPages = computed(() =>
      Math.ceil(vehicles.value.totalCount / itemsPerPage)
    );

    /* * ----------------------------------------------------
     * INITIALISATION ET WATCHERS
     * ----------------------------------------------------
     */
    onMounted(() => {
      fetchUsersMap(); // 👈 Charge la carte des utilisateurs au montage
      fetchvehicles();
      fetchKpiStats();
    });

    watch([searchQuery, startDate, endDate], () => {
      currentPage.value = 1;
      fetchvehicles();
    });

    // Re-calculer l'affichage (via 'computed') lorsque la carte utilisateur change
    watch(usersMap, () => {
      // Re-déclenche juste la re-calcul de transformedVehicles
    });

    watch(currentPage, () => {
      fetchvehicles();
    });


    // --- Logique de Pagination et de Filtres ---

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };

    const clearFilters = () => {
      startDate.value = "";
      endDate.value = "";
      searchQuery.value = "";
      currentPage.value = 1;
      fetchvehicles();
    };

    // --- Export PDF (Mis à jour pour inclure les noms d'agents) ---

    const downloadPdf = async () => {
      // Récupérer TOUS les véhicules (sans pagination) pour le PDF.
      const params = new URLSearchParams();
      params.append("sortColumn", sortColumn.value);
      params.append("sortDirection", sortDirection.value);
      params.append("limit", "99999");
      params.append("page", "1");

      const isDefaultSort =
        sortColumn.value === "entrance_date" && sortDirection.value === "desc";
      const hasOtherFilters =
        searchQuery.value || startDate.value || endDate.value;

      if (isDefaultSort && !hasOtherFilters) {
        params.append("todayOnly", "true");
      } else {
        if (searchQuery.value) params.append("search", searchQuery.value);
        if (startDate.value) params.append("startDate", startDate.value);
        if (endDate.value) params.append("endDate", endDate.value);
      }

      try {
        const url = `${API_URL}/vehicles?${params.toString()}`;

        const response = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.error ||
              `Erreur réseau: ${response.status} ${response.statusText}`
          );
        }

        const result = await response.json();
        
        // Transformation des données complètes pour le PDF
        const vehiclesToPrint = result.data.map(v => ({
            ...v,
            agent_entrance_name: usersMap.value[v.user_entrance] || v.user_entrance || "—",
            agent_departure_name: usersMap.value[v.user_departure] || v.user_departure || "—",
        })) || [];


        if (vehiclesToPrint.length === 0) {
          alert(
            "Aucun véhicule à télécharger selon les filtres actuels."
          );
          return;
        }

        // Construction du HTML du tableau (avec les noms d'agents)
        let pdfHtml = `
          <style>
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th, td { border: 1px solid #ccc; padding: 6px; text-align: left; font-size: 8px; }
            th { background-color: #f2f2f2; color: #ec4400; font-weight: bold; }
            h2 { color: #ec4400; text-align: center; margin-bottom: 10px; font-size: 16px; }
            .report-info { font-size: 10px; margin-bottom: 5px; }
            .kpi-section { margin-bottom: 20px; border: 1px solid #ddd; padding: 10px; }
            .kpi-item { font-size: 10px; margin: 3px 0; }
          </style>
          <h2>Rapport des Véhicules Enregistrés</h2>
          <div class="kpi-section">
            <div class="kpi-item"><strong>Total Véhicules (sortis aujourd'hui) :</strong> ${kpiStats.value?.totalVehicles || "N/A"}</div>
            <div class="kpi-item"><strong>Véhicules Présents :</strong> ${kpiStats.value?.ongoingVehicles || "N/A"}</div>
            <div class="kpi-item"><strong>Heure de Pointe :</strong> ${kpiStats.value?.peakHour || "N/A"}</div>
          </div>
          <div class="report-info">Total d'enregistrements: ${vehiclesToPrint.length}</div>
          <div class="report-info">Filtre Recherche: ${searchQuery.value || "Aucun"}</div>
          <div class="report-info">Filtre Date: ${
            isDefaultSort && !hasOtherFilters ? 'Aujourd\'hui' : `Du ${startDate.value || 'Début'} au ${endDate.value || 'Fin'}`
          }</div>
          <table>
            <thead>
              <tr>
                <th>Agent Entrée</th>
                <th>Agent Sortie</th>
                <th>Numéro pièce</th>
                <th>Immatriculation</th>
                <th>Nom Conducteur</th>
                <th>Prénoms Conducteur</th>
                <th>Entreprise</th>
                <th>Date</th>
                <th>Heure Entrée</th>
                <th>Heure Sortie</th>
              </tr>
            </thead>
            <tbody>
        `;

        vehiclesToPrint.forEach((v) => {
          pdfHtml += `
            <tr>
              <td>${v.agent_entrance_name || "—"}</td>
              <td>${v.agent_departure_name || "—"}</td>
              <td>${v.id_card || "—"}</td>
              <td>${v.id_car || "—"}</td>
              <td>${v.sirname || "—"}</td>
              <td>${v.first_name || "—"}</td>
              <td>${v.company || "—"}</td>
              <td>${v.entrance_date || "—"}</td>
              <td>${v.entrance_time || "—"}</td>
              <td>${v.exit_time || "—"}</td>
            </tr>
          `;
        });

        pdfHtml += `
            </tbody>
          </table>
        `;

        const options = {
          margin: 10,
          filename: `rapport_vehicles_${new Date()
            .toISOString()
            .slice(0, 10)}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
        };

        html2pdf().set(options).from(pdfHtml).save();
      } catch (err) {
        console.error("Erreur lors de l'export PDF:", err);
        alert(`Erreur lors de la génération du PDF: ${err.message}`);
      }
    };

    // --- Retour des Variables et Fonctions ---
    return {
      searchQuery,
      transformedVehicles, // Utilisation de la version transformée dans le template
      currentPage,
      totalPages,
      prevPage,
      nextPage,
      kpiStats,
      startDate,
      endDate,
      clearFilters,
      downloadPdf,
      errorMessage,
    };
  },
};
</script>